var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "skeleton-loader": true,
        loading: _vm.loading,
        chart: _vm.type == "chart"
      }
    },
    [
      _c(
        "div",
        {
          class: {
            "loader-content-wrapper": true,
            "skeleton-loader__bone": _vm.type == "chart",
            "min-height-220": _vm.type == "table" && _vm.loading,
            bordered: _vm.bordered
          }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading"
                }
              ],
              staticClass: "loader-content"
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.type == "text" && _vm.loading
            ? _c("div", { staticClass: "text-skeleton" }, [
                _c("p", { staticClass: "skeleton-loader__bone" }),
                _vm._v(" "),
                _c("p", { staticClass: "skeleton-loader__bone" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "table" && _vm.loading
            ? _c("div", { staticClass: "table-skeleton" }, [_vm._m(0)])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_c("div")]),
          _vm._v(" "),
          _c("th", { staticStyle: { width: "50%" } }, [_c("div")]),
          _vm._v(" "),
          _c("th", { staticStyle: { width: "30%" } }, [_c("div")])
        ])
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")]),
          _vm._v(" "),
          _c("td", [_c("div")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }